<template>
  <PlayerLayout>
    <div class="d-flex flex-column flex-md-row mx-12 my-6" slot="main">
      <v-sheet v-if="lesson" class="d-flex flex-column flex-1" color="grey-lighten-4" rounded>
        <div class="d-flex flex-column">
          <div class="cal-sans-regular font-size-26">{{ lesson.title || lesson.name }}</div>
          <div class="cal-sans-regular font-size-16 my-2">{{ lesson.description }}</div>
          
          <v-btn v-if="authUser" @click="riff" color="grey lighten-2" class="black--text elevation-0 mt-2">
            <v-icon left>mdi-guitar-pick-outline</v-icon>
            Riff
          </v-btn>

          <v-btn v-if="authUser && lesson.creator && authUser.uid === lesson.creator.id" @click="edit" color="grey lighten-2" class="black--text elevation-0 mt-2">
            <v-icon left>mdi-pencil</v-icon>
            Edit Lesson
          </v-btn>
        </div>
      </v-sheet>
      <v-sheet v-else-if="loading" class="d-flex flex-column flex-1" color="grey-lighten-4" rounded>
        <v-progress-linear indeterminate></v-progress-linear>
      </v-sheet>
    </div>
  </PlayerLayout>
</template>

<script>
import { getDoc, doc } from 'firebase/firestore';
import { db } from '@/firebase/init';
import PlayerLayout from '@/layouts/Player.vue';

export default {
  name: 'LessonPlayer',
  components: {
    PlayerLayout,
  },
  data() {
    return {
      lesson_id: null,
      loading: false,
      lesson: null,
    };
  },
  methods: {
    loadLesson() {
      this.loading = true;
      this.lesson_id = this.$route.params.id;
      if (this.lesson_id) {
        const lessonRef = doc(db, 'lessons', this.lesson_id);
        getDoc(lessonRef)
          .then((doc) => {
            if (doc.exists()) {
              let lessonData = doc.data();
              lessonData.id = doc.id;
              this.lesson = lessonData;
            } else {
              console.error('No such document!');
              this.lesson = null;
            }
            this.loading = false;
          })
          .catch((error) => {
            console.error('Error getting document:', error);
            this.loading = false;
            this.lesson = null;
          });
      } else {
        this.loading = false;
      }
    },
    async riff() {
      await this.$creator.riff('lesson', this.lesson.id, this.profile);
    },
    edit() {
      this.$creator.edit('lesson', this.lesson.id);
    }
  },
  created() {
    this.loadLesson();
  },
  watch: {
    '$route.params.id': {
      immediate: true,
      handler(newId, oldId) {
        if (newId !== oldId) {
          this.loadLesson();
        }
      },
    },
  },
};
</script>
